var map = {
	"./gourmet.jpg": "1e77",
	"./gourmet3.jpg": "3a51",
	"./gourmet4.jpg": "77f3",
	"./gourmetrda.jpg": "1b22",
	"./gourmetrde.jpg": "64c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae9c";